import { useMemo } from 'react'

type DynamicTextProps = {
  lang: string
  textNumber: number
  values: number[]
  gender: number
}

const DynamicText = ({
  lang,
  textNumber,
  values,
  gender,
}: DynamicTextProps) => {
  const text = useMemo(() => {
    const text =
      lang === 'fr' ? (
        textNumber === 1 ? (
          <>
            {values[0].toFixed(1) === '0.0' ||
            values[1].toFixed(1) === '100.0' ? (
              <>
                Vous faites aujourd'hui partie des <b>0,01%</b> de{' '}
                {gender === 0 ? 'femmes' : 'hommes'} les plus{' '}
                {gender === 0 ? 'petites' : 'petits'} de la population suisse
                totale; <b>99,9%</b> sont plus{' '}
                {gender === 0 ? 'grandes' : 'grands'} que vous. En moyenne, les{' '}
                {gender === 0 ? 'femmes' : 'hommes'} adultes mesurent{' '}
                <b>{gender === 0 ? '164,6 cm' : '177,4 cm'}</b>.
              </>
            ) : values[0].toFixed(1) === '100.0' ||
              values[1].toFixed(1) === '0.0' ? (
              <>
                Vous faites aujourd'hui partie des <b>0,01%</b> de{' '}
                {gender === 0 ? 'femmes' : 'hommes'} les plus{' '}
                {gender === 0 ? 'grandes' : 'grands'} de la population suisse
                totale; <b>99,9%</b> sont plus{' '}
                {gender === 0 ? 'petites' : 'petits'} que vous. En moyenne, les{' '}
                {gender === 0 ? 'femmes' : 'hommes'} adultes mesurent{' '}
                <b>{gender === 0 ? '164,6 cm' : '177,4 cm'}</b>.
              </>
            ) : (
              <>
                Aujourd'hui, <b>{values[0].toFixed(1).replace('.', ',')}%</b>{' '}
                des {gender === 0 ? 'femmes' : 'hommes'} de la population suisse
                totale sont plus {gender === 0 ? 'petites' : 'petits'} que vous;{' '}
                <b>{values[1].toFixed(1).replace('.', ',')}%</b> sont plus{' '}
                {gender === 0 ? 'grandes' : 'grands'}. En moyenne, les{' '}
                {gender === 0 ? 'femmes' : 'hommes'} adultes mesurent{' '}
                <b>{gender === 0 ? '164,6 cm' : '177,4 cm'}</b>.
              </>
            )}
          </>
        ) : gender === 0 ? (
          values[0].toFixed(1) === '100.0' || values[1].toFixed(1) === '0.0' ? (
            <>
              <b>Il y a 84 ans</b>, la taille moyenne des femmes était de{' '}
              <b>161,9 cm</b>, soit près de 3 cm de moins qu'aujourd'hui. Avec
              votre taille actuelle, vous auriez fait partie, en <b>1940</b>,
              des <b>0,01%</b> de femmes les plus grandes; <b>99,9%</b> auraient
              été plus petites que vous.
            </>
          ) : (
            <>
              <b>Il y a 84 ans</b>, la taille moyenne des femmes était de{' '}
              <b>161,9 cm</b>, soit près de 3 cm de moins qu'aujourd'hui. Avec
              votre taille actuelle, vous auriez fait partie, en <b>1940</b>,
              des <b>{values[1].toFixed(1).replace('.', ',')}%</b> de femmes les
              plus grandes; <b>{values[0].toFixed(1).replace('.', ',')}%</b>{' '}
              auraient été plus petites que vous.
            </>
          )
        ) : values[0].toFixed(1) === '100.0' ||
          values[1].toFixed(1) === '0.0' ? (
          <>
            En <b>1940</b>, la taille moyenne des hommes était de{' '}
            <b>174,4 cm</b>. En <b>1870</b>, elle n'était que de <b>163,3 cm</b>
            . Avec votre taille actuelle, vous auriez fait partie des{' '}
            <b>0,01%</b> d'hommes les plus grands il y a <b>150 ans</b>;{' '}
            <b>99,9%</b> auraient été plus petits que vous.
          </>
        ) : (
          <>
            En <b>1940</b>, la taille moyenne des hommes était de{' '}
            <b>174,4 cm</b>. En <b>1870</b>, elle n'était que de <b>163,3 cm</b>
            . Avec votre taille actuelle, vous auriez fait partie des{' '}
            <b>{values[1].toFixed(1).replace('.', ',')}%</b> d'hommes les plus
            grands il y a <b>150 ans</b>;{' '}
            <b>{values[0].toFixed(1).replace('.', ',')}%</b> auraient été plus
            petits que vous.
          </>
        )
      ) : textNumber === 1 ? (
        <>
          {values[0].toFixed(1) === '0.0' ||
          values[1].toFixed(1) === '100.0' ? (
            <>
              Sie gehören heute zu den <b>0,01 Prozent</b> kleinsten{' '}
              {gender === 0 ? 'Frauen' : 'Männern'} in der Schweizer
              Gesamtpopulation - <b>99,9 Prozent</b> sind grösser als Sie. Im
              Durchschnitt sind die erwachsenen{' '}
              {gender === 0 ? 'Frauen' : 'Männer'}{' '}
              <b>{gender === 0 ? '164,6 cm' : '177,4 cm'}</b> gross.
            </>
          ) : values[0].toFixed(1) === '100.0' ||
            values[1].toFixed(1) === '0.0' ? (
            <>
              Sie gehören heute zum grössten <b>0,01 Prozent</b> der Schweizer{' '}
              {gender === 0 ? 'Frauen' : 'Männer'} - <b>99,9 Prozent</b> sind
              kleiner als Sie. Im Durchschnitt sind die erwachsenen{' '}
              {gender === 0 ? 'Frauen' : 'Männer'}{' '}
              <b>{gender === 0 ? '164,6 cm' : '177,4 cm'}</b> gross.
            </>
          ) : (
            <>
              Heute sind <b>{values[0].toFixed(1).replace('.', ',')} Prozent</b>{' '}
              der {gender === 0 ? 'Frauen' : 'Männer'} aus der Schweizer
              Gesamtpopulation kleiner als Sie - und{' '}
              <b>{values[1].toFixed(1).replace('.', ',')} Prozent</b> sind
              grösser. Im Durchschnitt sind die erwachsenen{' '}
              {gender === 0 ? 'Frauen' : 'Männer'}{' '}
              <b>{gender === 0 ? '164,6 cm' : '177,4 cm'}</b> gross.
            </>
          )}
        </>
      ) : gender === 0 ? (
        values[0].toFixed(1) === '100.0' || values[1].toFixed(1) === '0.0' ? (
          <>
            <b>Vor 84 Jahren</b> lag die Durchschnittsgrösse von Frauen bei{' '}
            <b>161,9 cm</b> – knapp 3 cm kleiner als heute. Sie würden mit Ihrer
            heutigen Körpergrösse <b>1940</b> zu den <b>0,01 Prozent</b>{' '}
            grössten Frauen gehören - <b>99,9 Prozent</b> wären kleiner als Sie.
          </>
        ) : (
          <>
            <b>Vor 84 Jahren</b> lag die Durchschnittsgrösse von Frauen bei{' '}
            <b>161,9 cm</b> – knapp 3 cm kleiner als heute. Sie würden mit Ihrer
            heutigen Körpergrösse <b>1940</b> zu den{' '}
            <b>{values[1].toFixed(1).replace('.', ',')} Prozent</b> grössten
            Frauen gehören -{' '}
            <b>{values[0].toFixed(1).replace('.', ',')} Prozent</b> wären
            kleiner als Sie.
          </>
        )
      ) : values[0].toFixed(1) === '100.0' || values[1].toFixed(1) === '0.0' ? (
        <>
          <b>1940</b> lag die Durchschnittsgrösse von Männern bei{' '}
          <b>174,4 cm</b> – <b>1870</b> gar nur bei <b>163,3 cm</b>. Mit ihrer
          heutigen Körpergrösse hätten sie vor 150 Jahren zu den{' '}
          <b>0,01 Prozent</b> grössten Männern gehört – und <b>99,9 Prozent</b>{' '}
          wären kleiner als Sie gewesen.
        </>
      ) : (
        <>
          <b>1940</b> lag die Durchschnittsgrösse von Männern bei{' '}
          <b>174,4 cm</b> – <b>1870</b> gar nur bei <b>163,3 cm</b>. Mit ihrer
          heutigen Körpergrösse hätten sie vor 150 Jahren zu den{' '}
          <b>{values[1].toFixed(1).replace('.', ',')} Prozent</b> grössten
          Männern gehört – und{' '}
          <b>{values[0].toFixed(1).replace('.', ',')} Prozent</b> wären kleiner
          als Sie gewesen.
        </>
      )
    return text
  }, [lang, textNumber, values, gender])

  return <>{text}</>
}

export default DynamicText
